"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateRoute = PrivateRoute;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _components = require("../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PrivateRoute(_ref) {
  let {
    currentUser,
    defaultGuestPath,
    children,
    onRedirect
  } = _ref;
  if (currentUser === undefined) return /*#__PURE__*/_react.default.createElement(_components.Loading, {
    text: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.user.loading"
    })
  });
  if (currentUser === null) {
    onRedirect?.();
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
      to: {
        pathname: defaultGuestPath
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
}